import browser from '@lib/utils/browser.js'
// 3. 渠道判定优化 用户判断和获取 CQTME 渠道信息，包含 wrapperid 等 ，【建议所有渠道判定都换成改库】
import { getChannelInfo, channelTypes } from '@common-libs/tj-channel'
// 2. 平台判定优化 基本满足平台判定场景 各个app判定，小程序判定 具体可查看 d.ts 说明，【，建议所有渠道判定都换成改库】
import { getPlatform } from '@common-libs/tj-utils/platform'
const { isMpEnv } = getPlatform()
const isCtripApp = getPlatform().isCtripAppEnv
const isQunarApp = getPlatform().isQunarAppEnv

export default {
  data() {
    const { isQunarAppEnv } = this.platformEnv
    const tjChannelId = isQunarAppEnv ? channelTypes.QUNAR : getChannelInfo().channelId
    return {
      baseUrl: process.env.BASE_URL,
      passportHost: process.env.VUE_APP_PASSPORT_TUJIA_HOST,
      mTujiaHost: process.env.VUE_APP_TUJIA_HOST,
      pcTujiaHost: process.env.VUE_APP_PC_TUJIA_HOST,
      tujiaDomain: process.env.VUE_APP_TUJIA_DOMAIN,
      pcTravelHost: process.env.VUE_APP_PC_TUJIA_TRAVEL,
      picHost: process.env.VUE_APP_PIC_TUJIA_HOST,
      // 7 支付宝小程序 1微信小程序
      platform: -1,
      tjChannelId
    }
  },
  async created() {
    // 区分c，q，t平台
    if (process.env.VUE_APP_LOCAL !== 'Q' && process.env.VUE_APP_LOCAL !== 'C') {
      this.checkWxReady = this.checkWxReady.bind(this)
      const platform = await this.getEnv()
      this.platform = platform
      this.checkWxReady()
    } else {
      const Sniff = require('@/utils/q_sniff').Sniff
      if (window.hysdk) {
        if (Sniff.qunar) {
          this.platform = 5
        } else {
          this.platform = 6
        }
      }
    }
  },
  methods: {
    checkWxReady() {
      if (window.wx && window.wx.miniProgram && window.wx.miniProgram.getEnv) {
        // eslint-disable-next-line
        wx.miniProgram.getEnv((res) => {
          if (res.miniprogram) {
            this.platform = 1
          } else {
            this.platform = 3
          }
        })
      }
    },
    /** 用于判断环境 1｜微信小程序  2｜途家（蚂蚁） 3｜微信 4｜其他  7｜支付宝小程序 8｜支付宝浏览器  9｜携程app 10| 去哪儿app */
    getEnv() {
      return new Promise((resolve, reject) => {
        const ua = window.navigator.userAgent.toLowerCase()
        if (ua.indexOf('tujia') >= 0 || ua.indexOf('mayi') >= 0) {
          return resolve(2)
        } else if (ua.indexOf('micromessenger') >= 0 && window.wx && window.wx.miniProgram && window.wx.miniProgram.getEnv) {
          if (isMpEnv) {
            return resolve(1)
          } else {
            return resolve(3)
          }
        } else if (browser.versions.isZFBMiniProgram) {
          return resolve(7)
        } else if (ua.indexOf('alipayclient') >= 0) {
          // 支付宝浏览器
          return resolve(8)
        } else if (isCtripApp) {
          return resolve(9)
        } if (isQunarApp) {
          return resolve(10)
        } else {
          return resolve(4)
          // mock 去哪儿
          // return resolve(10)
        }
      })
    }
  }
}
